import { useFlags } from 'launchdarkly-react-client-sdk';

export const useFeatureResumeContentFromSection = () => {
  const flags = useFlags();
  return !!flags.resumeContentFromSection;
};
